import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["existingTab", "inviteTab", "existingPanel", "invitePanel"]

  showExisting() {
    this.existingTabTarget.classList.add("border-indigo-500", "text-indigo-600")
    this.existingTabTarget.classList.remove("border-transparent", "text-slate-500")
    this.inviteTabTarget.classList.remove("border-indigo-500", "text-indigo-600")
    this.inviteTabTarget.classList.add("border-transparent", "text-slate-500")

    this.existingPanelTarget.classList.remove("hidden")
    this.invitePanelTarget.classList.add("hidden")
  }

  showInvite() {
    this.inviteTabTarget.classList.add("border-indigo-500", "text-indigo-600")
    this.inviteTabTarget.classList.remove("border-transparent", "text-slate-500")
    this.existingTabTarget.classList.remove("border-indigo-500", "text-indigo-600")
    this.existingTabTarget.classList.add("border-transparent", "text-slate-500")

    this.invitePanelTarget.classList.remove("hidden")
    this.existingPanelTarget.classList.add("hidden")
  }
}
